// extracted by mini-css-extract-plugin
export const root = "AnimationBlock-module--root--10GeZ";
export const title = "AnimationBlock-module--title--1PGGU";
export const content = "AnimationBlock-module--content--2UKUP";